export enum CookiesHooksEnum {
  read = 'read'
};